export default {
  // https://mall.bowayalloy-htwire.com/  正式接口地址
  // https://bwhjtest.v-trend.cn   测试接口地址'
  // 正式接口地址
  baseUrl: 'https://mall.bowayalloy-htwire.com/api/index.php',
  imgUrl: "https://mall.bowayalloy-htwire.com/api/index.php",
  // 测试接口地址
  // baseUrl: 'https://bwhjtest.v-trend.cn/api/index.php',
  // imgUrl: "https://bwhjtest.v-trend.cn/api/index.php",
  //   baseUrl: 'http://bwhj.dianzhichuang.com.cn/api/index.php',
  // imgUrl: "http://bwhj.dianzhichuang.com.cn/api/index.php",


  header: {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'Authorization': ""
  },
}